var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{staticClass:"zgmh",attrs:{"src":require("@public/img/hotApply/zgmh.jpg")}})]),_c('p',{staticClass:"title"},[_vm._v("长按图片，识别民航临时乘机证明小程序")])])
}]

export { render, staticRenderFns }